import { render, staticRenderFns } from "./testBiletDialog.vue?vue&type=template&id=63d6860c&"
import script from "./testBiletDialog.vue?vue&type=script&lang=js&"
export * from "./testBiletDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports